import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { CreateQuoteLineResult, CreateQuoteLineService } from "@WhiteCap/Store/Service/OsnQuotes/OsnQuotesServices";

export interface CreateQuoteLineParameter {
    productId?: string;
    lineNumber?: string;
    qty?: string;
    warehosueName?: string;
    billToId?: string;
    shipToId?: string;
    onSuccess?: () => void;
    onError?: (message: string) => void;
}

type HandlerType = CustomApiHandler<CreateQuoteLineParameter, CreateQuoteLineResult>;

const DispatchBeginAddQuoteLine: HandlerType = props => {
    props.dispatch({
        type: "Custom/OsnCreateQuote/IsAddingQuoteLine",
        value: true
    });
};

const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

const RequestDataFromApi: HandlerType = async props => {
    const { productId, lineNumber, qty, billToId, shipToId, warehosueName } = props.apiParameter;
    try {
        const result = await CreateQuoteLineService({ productId, lineNumber, qty, billToId, shipToId, warehosueName });
        if (!result.isSuccess) {
            props.parameter.onError?.(result.message || "Something went wrong!");
        } else {
            props.apiResult = result;
            props.dispatch({
                type: "Custom/OsnCreateQuote/AddQuoteLine",
                quoteLine: result.quoteLine,
            });
            props.parameter.onSuccess?.();
        }
    } catch (error: any) {
        props.parameter.onError?.(error?.message || "An unexpected error occurred.");
    }
};

const DispatchCompleteAddQuoteLine: HandlerType = props => {
    props.dispatch({
        type: "Custom/OsnCreateQuote/IsAddingQuoteLine",
        value: false
    });
};

export const chain = [DispatchBeginAddQuoteLine, PopulateApiParameter, RequestDataFromApi, DispatchCompleteAddQuoteLine];
const createAndAddQuoteLine = createHandlerChainRunner(chain, "CreateAndAddQuoteLine");

export default createAndAddQuoteLine;
